import React from 'react'
import { TooltipNew } from '@elamajs/ui-kit'
import { InputComponent, TitleComponent, CopyComponent } from '@src/components/UtmGenerator'
import Checkbox from '../../Components/Checkbox'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'
import { transliterationParameters } from '@src/containers/UtmGenerator/helpers'
import { useWindowWidth } from '@src/containers/UtmGenerator/hooks'
import checkmark from '@src/containers/UtmGenerator/assets/checkmark.png'

import * as Styled from './Result.styled'

function Result() {
  const { userUtmLink, sendAnalyticCopy, transliteration, getTransliteration } = useHTTPContext()

  const [width] = useWindowWidth()

  return (
    <Styled.Section>
      <div className="container">
        <TitleComponent text="Ссылка с UTM-метками" icon={checkmark} />
        <Styled.Wrapper>
          <InputComponent
            id="utm-generator__result"
            labelText="Ссылка"
            type="text"
            name="result"
            autoComplete="off"
            onChange={e => e.preventDefault()}
            value={
              transliteration
                ? transliterationParameters(decodeURIComponent(userUtmLink))
                : userUtmLink
            }
          />
          <CopyComponent text={userUtmLink} getAnalyticClick={sendAnalyticCopy} />
        </Styled.Wrapper>
        <Styled.CheckboxRow>
          <Checkbox
            label="Транслитерировать параметры"
            name="additional settings"
            checked={transliteration}
            onChange={getTransliteration}
          />
          <Styled.Tooltip
            as={TooltipNew}
            icon="questionNew"
            direction={width > 1279 ? 'right' : 'bottom-end'}
            width="305px"
            content="Переводит кириллицу в&nbsp;URL и&nbsp;параметры utm-метки в&nbsp;латиницу, чтобы они корректно воспринимались всеми рекламными системами"
          />
        </Styled.CheckboxRow>
      </div>
    </Styled.Section>
  )
}

export default Result
